import useGetApi from 'src/api/useGetApi';

export interface UserBasicInfo {
  id: string;
  name: string;
  email?: string | null;
}

interface SearchUsersResponse {
  users: UserBasicInfo[];
}

export default function useUsersByIds(ids: string[], enabled = true) {
  const idsString = ids.join(',');

  return useGetApi<SearchUsersResponse, UserBasicInfo[]>({
    endpoint: 'core/users/search',
    queryParameters: { ids: idsString },
    options: {
      enabled: enabled && ids.length > 0,
    },
    transformResponse: (data) => data.users,
  });
}
